const Logo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="70 30 1160.94 326.87"
  >
    <g>
      <g id="Logo">
        <g display="none">
          <rect
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            y="371.49"
            width="1160.94"
            height="326.87"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1="-.84"
            y1="454.53"
            x2="1161.78"
            y2="454.53"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1=".84"
            y1="614"
            x2="1161.78"
            y2="614"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1=".84"
            y1="560.93"
            x2="1161.78"
            y2="560.93"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1=".84"
            y1="537.75"
            x2="1161.78"
            y2="537.75"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1=".87"
            y1="573.65"
            x2="1161.81"
            y2="573.65"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1="1087.44"
            y1="370.65"
            x2="1087.44"
            y2="698.35"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1="83.88"
            y1="371.49"
            x2="83.88"
            y2="698.35"
          />
        </g>
        <g display="none">
          <rect
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            y="0"
            width="1160.94"
            height="326.87"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1="-.84"
            y1="83.04"
            x2="1161.78"
            y2="83.04"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1=".84"
            y1="242.51"
            x2="1161.78"
            y2="242.51"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1=".84"
            y1="189.45"
            x2="1161.78"
            y2="189.45"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1=".84"
            y1="166.26"
            x2="1161.78"
            y2="166.26"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1=".87"
            y1="202.16"
            x2="1161.81"
            y2="202.16"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1="1087.44"
            y1="-.84"
            x2="1087.44"
            y2="326.87"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1="83.88"
            y1="0"
            x2="83.88"
            y2="326.87"
          />
        </g>
        <g>
          <path
            fill="#0081c6"
            d="M259.81,125.92v20.13c0,2.86.75,4.96,2.25,6.28,1.5,1.33,3.44,1.99,5.82,1.99,1.5,0,3.2-.24,5.11-.72v11.96c-2.45.95-5.42,1.43-8.89,1.43-6.41,0-11.29-1.8-14.67-5.42-3.37-3.61-5.06-8.69-5.06-15.23v-20.44h-9.81v-11.55h9.81v-12.16l15.43-5.01v17.17h13.18v11.55h-13.18Z"
          />
          <path
            fill="#0081c6"
            d="M298.94,137.16v29.02h-15.43v-75.22h15.43v30.45c1.84-2.72,4.19-4.8,7.05-6.23,2.86-1.43,6.03-2.15,9.5-2.15,12.26,0,18.39,7.26,18.39,21.77v31.37h-15.43v-30.66c0-3.61-.66-6.25-1.99-7.92-1.33-1.67-3.42-2.5-6.28-2.5-3.41,0-6.13,1.09-8.18,3.27-2.04,2.18-3.07,5.11-3.07,8.79"
          />
          <g>
            <path
              fill="#0081c6"
              d="M344.34,114.37h15.43v51.81h-15.43v-51.81Z"
            />
            <path
              fill="#0081c6"
              d="M344.01,99.27c0-4.44,3.63-8.06,8.06-8.06s8.06,3.63,8.06,8.06-3.62,8.06-8.06,8.06-8.06-3.62-8.06-8.06"
            />
          </g>
          <path
            fill="#0081c6"
            d="M420.76,134.81v31.37h-15.43v-30.66c0-3.61-.66-6.25-1.99-7.92-1.33-1.67-3.42-2.5-6.28-2.5-3.41,0-6.13,1.09-8.18,3.27-2.04,2.18-3.07,5.11-3.07,8.79v29.02h-15.43v-36.99c0-5.52-.27-10.46-.82-14.82h14.51l1.02,8.18c1.84-3.07,4.24-5.42,7.2-7.05s6.32-2.45,10.07-2.45c12.26,0,18.39,7.26,18.39,21.77Z"
          />
          <path
            fill="#0081c6"
            d="M467.04,166.18l-20.34-23.2v23.2h-15.43v-75.22h15.43v45.68l19.42-22.18h18.5l-21.97,24.83,23.3,26.88h-18.91Z"
          />
          <path
            fill="#0081c6"
            d="M500,163.63c-3.68-2.18-6.52-5.28-8.53-9.3-2.01-4.02-3.01-8.72-3.01-14.1s1-10.08,3.01-14.1c2.01-4.02,4.85-7.12,8.53-9.3,3.68-2.18,7.94-3.27,12.77-3.27s9.09,1.09,12.77,3.27c3.68,2.18,6.52,5.28,8.53,9.3,2.01,4.02,3.01,8.72,3.01,14.1s-1.01,10.08-3.01,14.1c-2.01,4.02-4.85,7.12-8.53,9.3-3.68,2.18-7.94,3.27-12.77,3.27s-9.1-1.09-12.77-3.27ZM524.53,154.99c2.72-3.37,4.09-8.29,4.09-14.77s-1.4-11.12-4.19-14.56c-2.79-3.44-6.68-5.16-11.65-5.16s-8.96,1.72-11.75,5.16c-2.79,3.44-4.19,8.3-4.19,14.56s1.38,11.39,4.14,14.77c2.76,3.37,6.69,5.06,11.8,5.06s9.03-1.69,11.75-5.06Z"
          />
          <path
            fill="#0081c6"
            d="M565.15,100.01c-1.53,1.53-2.3,4.17-2.3,7.92v6.85h12.57v6.54h-12.57v44.86h-8.28v-44.86h-10.02v-6.54h10.02v-7.87c0-5.38,1.34-9.45,4.04-12.21,2.69-2.76,6.45-4.14,11.29-4.14,2.38,0,4.7.31,6.95.92v7.05c-1.91-.54-3.68-.82-5.31-.82-2.73,0-4.85.77-6.39,2.3Z"
          />
          <path fill="#0081c6" d="M587.37,90.97h15.43v75.22h-15.43v-75.22Z" />
          <path
            fill="#0081c6"
            d="M695.91,114.47l-22.79,51.71h-13.08l-22.48-51.71h16.15l13.29,33.52,13.69-33.52h15.23Z"
          />
          <g>
            <path
              fill="#0081c6"
              d="M613.34,114.37h15.43v51.81h-15.43v-51.81Z"
            />
            <path
              fill="#0081c6"
              d="M613,99.27c0-4.44,3.63-8.06,8.06-8.06s8.06,3.63,8.06,8.06-3.62,8.06-8.06,8.06-8.06-3.62-8.06-8.06"
            />
          </g>
          <path
            fill="#0081c6"
            d="M780.93,134.81v31.37h-15.43v-30.66c0-3.61-.66-6.25-1.99-7.92-1.33-1.67-3.42-2.5-6.28-2.5-3.41,0-6.13,1.09-8.18,3.27-2.04,2.18-3.07,5.11-3.07,8.79v29.02h-15.43v-36.99c0-5.52-.27-10.46-.82-14.82h14.51l1.02,8.18c1.84-3.07,4.24-5.42,7.2-7.05,2.96-1.64,6.32-2.45,10.07-2.45,12.26,0,18.39,7.26,18.39,21.77Z"
          />
          <path
            fill="#0081c6"
            d="M846.42,114.37v49.46c0,8.24-2.39,14.51-7.15,18.8-4.77,4.29-11.72,6.44-20.85,6.44-8.24,0-15.4-1.6-21.46-4.8l2.35-11.45c6.27,3.13,12.47,4.7,18.6,4.7,4.43,0,7.73-1.04,9.91-3.12,2.18-2.08,3.27-5.23,3.27-9.45v-8.99c-1.64,2.52-3.92,4.62-6.85,6.28-2.93,1.67-6.17,2.5-9.71,2.5-4.5,0-8.48-1.07-11.96-3.22-3.47-2.15-6.2-5.18-8.18-9.1-1.98-3.92-2.96-8.43-2.96-13.54s.99-9.62,2.96-13.54c1.98-3.92,4.7-6.95,8.18-9.1,3.48-2.15,7.46-3.22,11.96-3.22,3.61,0,6.88.78,9.81,2.35,2.93,1.57,5.18,3.68,6.74,6.34v-7.36h15.33ZM827.88,149.27c2.15-2.49,3.22-5.94,3.22-10.37s-1.06-7.78-3.17-10.27c-2.11-2.49-5.08-3.73-8.89-3.73s-6.81,1.24-8.99,3.73c-2.18,2.49-3.27,5.91-3.27,10.27s1.09,7.8,3.27,10.32c2.18,2.52,5.18,3.78,8.99,3.78s6.69-1.24,8.84-3.73Z"
          />
          <path
            fill="#0081c6"
            d="M894.53,159.85c-4.8-4.77-7.2-11.27-7.2-19.52,0-5.38,1.16-10.13,3.47-14.26,2.32-4.12,5.57-7.32,9.76-9.61,4.19-2.28,9.04-3.42,14.56-3.42,3.75,0,7.39.58,10.93,1.74,3.54,1.16,6.37,2.73,8.48,4.7l-4.09,10.73c-2.04-1.64-4.29-2.91-6.75-3.83-2.45-.92-4.84-1.38-7.15-1.38-4.23,0-7.51,1.28-9.86,3.83-2.35,2.56-3.53,6.29-3.53,11.19s1.16,8.74,3.48,11.29c2.32,2.55,5.62,3.83,9.91,3.83,2.32,0,4.7-.46,7.15-1.38s4.7-2.2,6.75-3.83l4.09,10.73c-2.25,1.98-5.18,3.53-8.79,4.65-3.61,1.12-7.39,1.69-11.34,1.69-8.45,0-15.07-2.38-19.88-7.15Z"
          />
          <path
            fill="#0081c6"
            d="M954.76,163.73c-4.12-2.18-7.29-5.31-9.5-9.4-2.21-4.09-3.32-8.86-3.32-14.31s1.11-10.22,3.32-14.31c2.21-4.09,5.38-7.22,9.5-9.4,4.12-2.18,8.94-3.27,14.46-3.27s10.22,1.09,14.31,3.27c4.09,2.18,7.24,5.31,9.45,9.4,2.21,4.09,3.32,8.86,3.32,14.31s-1.11,10.22-3.32,14.31c-2.21,4.09-5.37,7.22-9.45,9.4-4.09,2.18-8.86,3.27-14.31,3.27s-10.34-1.09-14.46-3.27ZM977.96,151.47c2.01-2.52,3.01-6.34,3.01-11.45s-1.01-8.84-3.01-11.39c-2.01-2.56-4.92-3.83-8.74-3.83s-6.85,1.28-8.89,3.83c-2.04,2.55-3.07,6.35-3.07,11.39,0,10.15,3.99,15.23,11.96,15.23,3.81,0,6.73-1.26,8.74-3.78Z"
          />
          <path
            fill="#0081c6"
            d="M1083.39,118.41c2.89,3.58,4.34,9.04,4.34,16.4v31.37h-15.43v-30.86c0-3.61-.58-6.22-1.74-7.82-1.16-1.6-3.07-2.4-5.72-2.4-3.14,0-5.55,1.09-7.26,3.27-1.7,2.18-2.55,5.25-2.55,9.2v28.61h-15.43v-30.86c0-3.54-.6-6.13-1.79-7.77-1.19-1.64-3.08-2.45-5.67-2.45-3.14,0-5.57,1.09-7.31,3.27-1.74,2.18-2.61,5.25-2.61,9.2v28.61h-15.43v-36.99c0-5.52-.27-10.46-.82-14.82h14.51l.92,7.77c1.57-2.93,3.76-5.18,6.59-6.74,2.83-1.57,6.08-2.35,9.76-2.35,7.7,0,12.81,3.2,15.33,9.61,1.7-2.93,4.07-5.26,7.1-7,3.03-1.74,6.35-2.61,9.96-2.61,5.93,0,10.34,1.79,13.23,5.36Z"
          />
          <g>
            <path
              fill="#0081c6"
              d="M704.66,114.37h15.43v51.81h-15.43v-51.81Z"
            />
            <path
              fill="#0081c6"
              d="M704.32,99.27c0-4.44,3.63-8.06,8.06-8.06s8.06,3.63,8.06,8.06-3.62,8.06-8.06,8.06-8.06-3.62-8.06-8.06"
            />
          </g>
          <path
            fill="#0081c6"
            d="M856.94,157.06c0-5.88,4.1-10.13,9.98-10.13,5.88,0,9.88,4.14,9.88,10.13,0,5.77-3.99,10.02-9.98,10.03-5.77,0-9.88-4.24-9.88-10.02Z"
          />
        </g>
        <g>
          <g>
            <path
              fill="#0e2638"
              d="M295.52,202.13h-6.77c-.22,0-.4.14-.47.33,0,0-2.71,7.71-4.09,11.64-.72,2.05-1.93,5.49-2.59,8.04-.05.2-.24.38-.49.38-.22,0-.43-.14-.49-.38-.69-2.56-1.96-6-2.72-8.07-1.72-4.71-4.24-11.62-4.24-11.62-.07-.19-.26-.33-.47-.33h-6.78c-.28,0-.51.23-.51.51,0,.07.01.13.04.19l11.22,28.24-4.39,10.98c-.02.06-.04.12-.04.19,0,.28.23.51.51.51h6.57c.21,0,.4-.13.47-.32l15.73-39.6c.02-.06.03-.12.03-.18,0-.28-.23-.51-.51-.51Z"
            />
            <path
              fill="#0e2638"
              d="M242.47,207.01c-.04.08-.18.29-.46.29s-.51-.23-.51-.51c0-.51.54-4.31.54-13.88v-2.95c0-.28-.23-.51-.51-.51h-6.47c-.28,0-.51.23-.51.51v40.61c0,.28.23.51.51.51h5.94c.28,0,.51-.22.51-.5v-4.14c0-.28.23-.51.51-.51.16,0,.35.07.47.3.6,1.22,3.16,5.44,9.44,5.44,7.46,0,13.57-6.51,13.57-15.07s-6.11-15.07-13.57-15.07c-5.24,0-8.23,3.04-9.45,5.48ZM258.01,216.6c0,4.48-3.54,8.11-7.91,8.11s-7.91-3.63-7.91-8.11,3.54-8.11,7.91-8.11,7.91,3.63,7.91,8.11Z"
            />
          </g>
          <g>
            <path
              fill="#0e2638"
              d="M560.06,214.7c-.28,0-.51-.23-.51-.51v-6c0-.28.23-.51.51-.51h17.52c1.2,0,1.98.98,2.02,1.94,0,0,.04,1,0,2.03-.34,11.88-7.62,20.2-19.34,20.2s-20.53-9.52-20.53-21.41,8.83-21.66,20.72-21.66c9.34,0,14.26,5.87,14.54,6.11.2.19.21.51.02.71l-4.45,4.72c-.19.2-.51.21-.71.02-.24-.25-3.63-4.2-9.39-4.2-7.76,0-13.11,6.54-13.11,14.3s5.39,14.11,12.98,14.11c6.05,0,10.37-3.21,11.41-8.48.03-.17.05-.28.05-.37,0-.56-.45-1.01-1.01-1.01h-10.72Z"
            />
            <path
              fill="#0e2638"
              d="M594.09,231.54c-5.67,0-9.92-4.15-9.92-11.57v-17.34c0-.28.23-.51.51-.51h6.47c.28,0,.51.23.51.51v15.52c0,4.53,2.01,6.71,5.7,6.71s5.95-2.35,5.95-6.71v-15.52c0-.28.23-.51.51-.51h6.47c.28,0,.51.23.51.51v27.93c0,.28-.23.51-.51.51h-2.53s-1.53,0-1.53,0h-1.88c-.28,0-.51-.22-.51-.5v-5.15c0-.28-.23-.51-.51-.51s-.45.17-.52.44c-.7,2.41-2.89,6.19-8.71,6.19Z"
            />
            <path
              fill="#0e2638"
              d="M378.02,201.41c-8.39,0-15.19,6.8-15.19,15.2s6.8,15.19,15.19,15.19,15.19-6.8,15.19-15.19-6.8-15.2-15.19-15.2ZM378.02,224.71c-4.37,0-7.91-3.63-7.91-8.11s3.54-8.11,7.91-8.11,7.91,3.63,7.91,8.11-3.54,8.11-7.91,8.11Z"
            />
            <path
              fill="#0e2638"
              d="M356.87,208.6c-1.82,0-3.65.9-4.68,3.02-.72,1.48-.96,3.54-.96,6.3v12.64c.01.28-.21.51-.49.51h-6.47c-.28,0-.51-.23-.51-.51v-27.93c0-.28.23-.51.51-.51h5.94c.28,0,.51.22.51.5v5.15c0,.28.23.51.51.51s.44-.19.52-.46c.51-1.75,1.31-3.88,2.95-5.24.9-.74,2.03-1.08,3.16-1.08.95,0,1.97.23,3.02.9.14.09.22.24.22.42v6.33c0,.28-.23.51-.51.51-.1,0-.2-.04-.28-.09-.87-.49-1.98-.97-3.43-.97Z"
            />
            <path
              fill="#0e2638"
              d="M480.06,208.6c-1.82,0-3.65.9-4.68,3.02-.72,1.48-.96,3.54-.96,6.3v12.64c.01.28-.21.51-.49.51h-6.47c-.28,0-.51-.23-.51-.51v-27.93c0-.28.23-.51.51-.51h5.94c.28,0,.51.22.51.5v5.15c0,.28.23.51.51.51s.44-.19.52-.46c.51-1.75,1.31-3.88,2.95-5.24.9-.74,2.03-1.08,3.16-1.08.95,0,1.97.23,3.02.9.14.09.22.24.22.42v6.33c0,.28-.23.51-.51.51-.1,0-.2-.04-.28-.09-.87-.49-1.98-.97-3.43-.97Z"
            />
            <path
              fill="#0e2638"
              d="M630.33,208.6c-1.82,0-3.65.9-4.68,3.02-.72,1.48-.96,3.54-.96,6.3v12.64c.01.28-.21.51-.49.51h-6.47c-.28,0-.51-.23-.51-.51v-27.93c0-.28.23-.51.51-.51h5.94c.28,0,.51.22.51.5v5.15c0,.28.23.51.51.51s.44-.19.52-.46c.51-1.75,1.31-3.88,2.95-5.24.9-.74,2.03-1.08,3.16-1.08.95,0,1.97.23,3.02.9.14.09.22.24.22.42v6.33c0,.28-.23.51-.51.51-.1,0-.2-.04-.28-.09-.87-.49-1.98-.97-3.43-.97Z"
            />
            <path
              fill="#0e2638"
              d="M648.48,231.54c-5.67,0-9.92-4.15-9.92-11.57v-17.34c0-.28.23-.51.51-.51h6.47c.28,0,.51.23.51.51v15.52c0,4.53,2.01,6.71,5.7,6.71s5.95-2.35,5.95-6.71v-15.52c0-.28.23-.51.51-.51h6.47c.28,0,.51.23.51.51v27.93c0,.28-.23.51-.51.51h-2.53s-1.53,0-1.53,0h-1.88c-.28,0-.51-.22-.51-.5v-5.15c0-.28-.23-.51-.51-.51s-.45.17-.52.44c-.7,2.41-2.89,6.19-8.71,6.19Z"
            />
            <path
              fill="#0e2638"
              d="M535.3,202.13h-6.77c-.22,0-.4.14-.47.33,0,0-2.71,7.71-4.09,11.64-.72,2.05-1.93,5.49-2.59,8.04-.05.2-.24.38-.49.38-.22,0-.43-.14-.49-.38-.69-2.56-1.96-6-2.72-8.07-1.72-4.71-4.24-11.62-4.24-11.62-.07-.19-.26-.33-.47-.33h-6.78c-.28,0-.51.23-.51.51,0,.07.01.13.04.19l11.22,28.24-4.39,10.98c-.02.06-.04.12-.04.19,0,.28.23.51.51.51h6.57c.21,0,.4-.13.47-.32l15.73-39.6c.02-.06.03-.12.03-.18,0-.28-.23-.51-.51-.51Z"
            />
            <path
              fill="#0e2638"
              d="M324.38,189.45h-12.92c-1.12,0-2.02.9-2.02,2.02v39.1c0,.28.23.51.51.51h6.46c.28,0,.51-.23.51-.51v-9.72c0-.56.45-1.01,1.01-1.01h6.45c8.65,0,15.45-6.8,15.45-15.19s-6.8-15.2-15.45-15.2ZM323.73,213.01h-5.8c-.56,0-1.01-.45-1.01-1.01v-14.72c0-.56.45-1.01,1.01-1.01h5.8c4.88,0,8.63,3.75,8.63,8.37s-3.75,8.37-8.63,8.37Z"
            />
            <path
              fill="#0e2638"
              d="M495.77,209.05c0-.28.23-.51.51-.51h5.99c.28,0,.51-.23.51-.51v-5.4c0-.28-.23-.51-.51-.51h-6.68c-.28,0-.51-.23-.51-.51v-6.72c0-.28-.23-.51-.51-.51h-5.78c-.28,0-.51.23-.51.51v27.39c0,7.06,3.43,9.5,7.91,9.5,2.85,0,4.54-.87,5.25-1.21.22-.1.33-.28.33-.53v-4.38c-.01-.34-.33-.62-.75-.47-.91.34-1.68.56-2.61.56-1.34,0-2.66-.63-2.66-3.1v-13.63Z"
            />
            <path
              fill="#0e2638"
              d="M415.17,231.67c7.46,0,13.57-6.51,13.57-15.07s-6.11-15.07-13.57-15.07c-6.28,0-8.84,4.22-9.44,5.44-.12.24-.31.3-.47.3-.28,0-.51-.23-.51-.51v-4.14c0-.28-.23-.51-.51-.51h-5.94c-.28,0-.51.23-.51.51v39.6c0,.28.23.51.51.51h6.47c.28,0,.51-.23.51-.51v-1.94c0-9.57-.54-13.37-.54-13.88,0-.28.23-.51.51-.51s.42.21.46.29c1.23,2.43,4.21,5.48,9.45,5.48ZM413.34,224.71c-4.37,0-7.91-3.63-7.91-8.11s3.54-8.11,7.91-8.11,7.91,3.63,7.91,8.11-3.54,8.11-7.91,8.11Z"
            />
            <path
              fill="#0e2638"
              d="M447.45,201.41c-8.39,0-14.57,6.8-14.57,15.19s6.41,15.19,15.13,15.19c4.72,0,8.33-1.65,10.74-3.58.21-.17.26-.47.1-.7l-2.68-3.71c-.16-.23-.48-.28-.71-.11-1.19.77-2.93,2.15-6.89,2.15-3.34,0-6.31-1.95-7.71-5.02-.13-.29-.33-.72-.33-.91,0-.28.23-.51.51-.51,0,0,17.38,0,18.59,0,.81,0,1.99-.56,2.06-1.98.45-8.95-4.53-16.03-14.25-16.03ZM453.86,214.26h-13.04c-.28,0-.51-.23-.51-.51,0-.13.12-.55.23-.9,1.06-3.29,3.73-5.22,7.29-5.22,3.01,0,5.26,1.5,6.43,3.8.33.66.61,1.51.61,1.8,0,.56-.45,1.01-1.01,1.01Z"
            />
          </g>
        </g>
        <g>
          <path
            fill="#0081c6"
            d="M209.08,140.85c.05-.87.07-1.74.07-2.62,0-29.89-27.81-54.1-62.15-54.1s-62.16,24.21-62.16,54.1c0,.88.03,1.75.07,2.62,0,.13.02.25.02.37,2.61,44.68,62.07,102.41,62.07,102.41,0,0,59.44-57.73,62.05-102.41.01-.12.01-.24.02-.37"
          />
          <path
            fill="#fff"
            d="M188.5,141.66l-36.47-28.37c-2.98-2.31-7.1-2.31-10.07,0l-36.45,28.37c-3.57,2.79-4.23,7.94-1.43,11.51,1.62,2.08,4.03,3.17,6.48,3.17,1.76,0,3.54-.58,5.04-1.74v-.02l2.83-2.2,4.03,28.25c.21,1.47.85,2.88,1.72,3.91.87,1.03,1.97,1.63,2.98,1.63h9.15c4,0,3.74-4.02,3.74-4.02l-.85-13.33c-.08-1.88,1.08-3.41,2.59-3.41h10.62c1.52,0,2.69,1.53,2.65,3.41l-.57,13.33v.06c-.01.48.01,3.96,3.74,3.96h9.21c1.02,0,2.1-.6,2.95-1.63.86-1.04,1.47-2.45,1.64-3.91l3.58-28.22,2.81,2.18c3.58,2.79,8.73,2.14,11.52-1.42,2.77-3.57,2.13-8.72-1.43-11.51"
          />
        </g>
        <g>
          <rect
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            y="750.97"
            width="1160.94"
            height="326.87"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1="-.84"
            y1="834.01"
            x2="1161.78"
            y2="834.01"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1=".84"
            y1="993.48"
            x2="1161.78"
            y2="993.48"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1=".84"
            y1="940.42"
            x2="1161.78"
            y2="940.42"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1=".84"
            y1="917.23"
            x2="1161.78"
            y2="917.23"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1=".87"
            y1="953.13"
            x2="1161.81"
            y2="953.13"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1="1087.44"
            y1="750.13"
            x2="1087.44"
            y2="1077.84"
          />
          <line
            fill="none"
            stroke="#d1def9"
            strokeMiterlimit="10"
            strokeWidth=".5px"
            x1="83.88"
            y1="750.97"
            x2="83.88"
            y2="1077.84"
          />
        </g>
        <g>
          <g>
            <path
              fill="#fff"
              d="M295.52,953.1h-6.77c-.22,0-.4.14-.47.33,0,0-2.71,7.71-4.09,11.64-.72,2.05-1.93,5.49-2.59,8.04-.05.2-.24.38-.49.38-.22,0-.43-.14-.49-.38-.69-2.56-1.96-6-2.72-8.07-1.72-4.71-4.24-11.62-4.24-11.62-.07-.19-.26-.33-.47-.33h-6.78c-.28,0-.51.23-.51.51,0,.07.01.13.04.19l11.22,28.24-4.39,10.98c-.02.06-.04.12-.04.19,0,.28.23.51.51.51h6.57c.21,0,.4-.13.47-.32l15.73-39.6c.02-.06.03-.12.03-.18,0-.28-.23-.51-.51-.51Z"
            />
            <path
              fill="#fff"
              d="M242.47,957.98c-.04.08-.18.29-.46.29s-.51-.23-.51-.51c0-.51.54-4.31.54-13.88v-2.95c0-.28-.23-.51-.51-.51h-6.47c-.28,0-.51.23-.51.51v40.61c0,.28.23.51.51.51h5.94c.28,0,.51-.22.51-.5v-4.14c0-.28.23-.51.51-.51.16,0,.35.07.47.3.6,1.22,3.16,5.44,9.44,5.44,7.46,0,13.57-6.51,13.57-15.07s-6.11-15.07-13.57-15.07c-5.24,0-8.23,3.04-9.45,5.48ZM258.01,967.57c0,4.48-3.54,8.11-7.91,8.11s-7.91-3.63-7.91-8.11,3.54-8.11,7.91-8.11,7.91,3.63,7.91,8.11Z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M560.06,965.67c-.28,0-.51-.23-.51-.51v-6c0-.28.23-.51.51-.51h17.52c1.2,0,1.98.98,2.02,1.94,0,0,.04,1,0,2.03-.34,11.88-7.62,20.2-19.34,20.2s-20.53-9.52-20.53-21.41,8.83-21.66,20.72-21.66c9.34,0,14.26,5.87,14.54,6.11.2.19.21.51.02.71l-4.45,4.72c-.19.2-.51.21-.71.02-.24-.25-3.63-4.2-9.39-4.2-7.76,0-13.11,6.54-13.11,14.3s5.39,14.11,12.98,14.11c6.05,0,10.37-3.21,11.41-8.48.03-.17.05-.28.05-.37,0-.56-.45-1.01-1.01-1.01h-10.72Z"
            />
            <path
              fill="#fff"
              d="M594.09,982.51c-5.67,0-9.92-4.15-9.92-11.57v-17.34c0-.28.23-.51.51-.51h6.47c.28,0,.51.23.51.51v15.52c0,4.53,2.01,6.71,5.7,6.71s5.95-2.35,5.95-6.71v-15.52c0-.28.23-.51.51-.51h6.47c.28,0,.51.23.51.51v27.93c0,.28-.23.51-.51.51h-2.53s-1.53,0-1.53,0h-1.88c-.28,0-.51-.22-.51-.5v-5.15c0-.28-.23-.51-.51-.51s-.45.17-.52.44c-.7,2.41-2.89,6.19-8.71,6.19Z"
            />
            <path
              fill="#fff"
              d="M378.02,952.38c-8.39,0-15.19,6.8-15.19,15.2s6.8,15.19,15.19,15.19,15.19-6.8,15.19-15.19-6.8-15.2-15.19-15.2ZM378.02,975.68c-4.37,0-7.91-3.63-7.91-8.11s3.54-8.11,7.91-8.11,7.91,3.63,7.91,8.11-3.54,8.11-7.91,8.11Z"
            />
            <path
              fill="#fff"
              d="M356.87,959.57c-1.82,0-3.65.9-4.68,3.02-.72,1.48-.96,3.54-.96,6.3v12.64c.01.28-.21.51-.49.51h-6.47c-.28,0-.51-.23-.51-.51v-27.93c0-.28.23-.51.51-.51h5.94c.28,0,.51.22.51.5v5.15c0,.28.23.51.51.51s.44-.19.52-.46c.51-1.75,1.31-3.88,2.95-5.24.9-.74,2.03-1.08,3.16-1.08.95,0,1.97.23,3.02.9.14.09.22.24.22.42v6.33c0,.28-.23.51-.51.51-.1,0-.2-.04-.28-.09-.87-.49-1.98-.97-3.43-.97Z"
            />
            <path
              fill="#fff"
              d="M480.06,959.57c-1.82,0-3.65.9-4.68,3.02-.72,1.48-.96,3.54-.96,6.3v12.64c.01.28-.21.51-.49.51h-6.47c-.28,0-.51-.23-.51-.51v-27.93c0-.28.23-.51.51-.51h5.94c.28,0,.51.22.51.5v5.15c0,.28.23.51.51.51s.44-.19.52-.46c.51-1.75,1.31-3.88,2.95-5.24.9-.74,2.03-1.08,3.16-1.08.95,0,1.97.23,3.02.9.14.09.22.24.22.42v6.33c0,.28-.23.51-.51.51-.1,0-.2-.04-.28-.09-.87-.49-1.98-.97-3.43-.97Z"
            />
            <path
              fill="#fff"
              d="M630.33,959.57c-1.82,0-3.65.9-4.68,3.02-.72,1.48-.96,3.54-.96,6.3v12.64c.01.28-.21.51-.49.51h-6.47c-.28,0-.51-.23-.51-.51v-27.93c0-.28.23-.51.51-.51h5.94c.28,0,.51.22.51.5v5.15c0,.28.23.51.51.51s.44-.19.52-.46c.51-1.75,1.31-3.88,2.95-5.24.9-.74,2.03-1.08,3.16-1.08.95,0,1.97.23,3.02.9.14.09.22.24.22.42v6.33c0,.28-.23.51-.51.51-.1,0-.2-.04-.28-.09-.87-.49-1.98-.97-3.43-.97Z"
            />
            <path
              fill="#fff"
              d="M648.48,982.51c-5.67,0-9.92-4.15-9.92-11.57v-17.34c0-.28.23-.51.51-.51h6.47c.28,0,.51.23.51.51v15.52c0,4.53,2.01,6.71,5.7,6.71s5.95-2.35,5.95-6.71v-15.52c0-.28.23-.51.51-.51h6.47c.28,0,.51.23.51.51v27.93c0,.28-.23.51-.51.51h-2.53s-1.53,0-1.53,0h-1.88c-.28,0-.51-.22-.51-.5v-5.15c0-.28-.23-.51-.51-.51s-.45.17-.52.44c-.7,2.41-2.89,6.19-8.71,6.19Z"
            />
            <path
              fill="#fff"
              d="M535.3,953.1h-6.77c-.22,0-.4.14-.47.33,0,0-2.71,7.71-4.09,11.64-.72,2.05-1.93,5.49-2.59,8.04-.05.2-.24.38-.49.38-.22,0-.43-.14-.49-.38-.69-2.56-1.96-6-2.72-8.07-1.72-4.71-4.24-11.62-4.24-11.62-.07-.19-.26-.33-.47-.33h-6.78c-.28,0-.51.23-.51.51,0,.07.01.13.04.19l11.22,28.24-4.39,10.98c-.02.06-.04.12-.04.19,0,.28.23.51.51.51h6.57c.21,0,.4-.13.47-.32l15.73-39.6c.02-.06.03-.12.03-.18,0-.28-.23-.51-.51-.51Z"
            />
            <path
              fill="#fff"
              d="M324.38,940.42h-12.92c-1.12,0-2.02.9-2.02,2.02v39.1c0,.28.23.51.51.51h6.46c.28,0,.51-.23.51-.51v-9.72c0-.56.45-1.01,1.01-1.01h6.45c8.65,0,15.45-6.8,15.45-15.19s-6.8-15.2-15.45-15.2ZM323.73,963.98h-5.8c-.56,0-1.01-.45-1.01-1.01v-14.72c0-.56.45-1.01,1.01-1.01h5.8c4.88,0,8.63,3.75,8.63,8.37s-3.75,8.37-8.63,8.37Z"
            />
            <path
              fill="#fff"
              d="M495.77,960.02c0-.28.23-.51.51-.51h5.99c.28,0,.51-.23.51-.51v-5.4c0-.28-.23-.51-.51-.51h-6.68c-.28,0-.51-.23-.51-.51v-6.72c0-.28-.23-.51-.51-.51h-5.78c-.28,0-.51.23-.51.51v27.39c0,7.06,3.43,9.5,7.91,9.5,2.85,0,4.54-.87,5.25-1.21.22-.1.33-.28.33-.53v-4.38c-.01-.34-.33-.62-.75-.47-.91.34-1.68.56-2.61.56-1.34,0-2.66-.63-2.66-3.1v-13.63Z"
            />
            <path
              fill="#fff"
              d="M415.17,982.64c7.46,0,13.57-6.51,13.57-15.07s-6.11-15.07-13.57-15.07c-6.28,0-8.84,4.22-9.44,5.44-.12.24-.31.3-.47.3-.28,0-.51-.23-.51-.51v-4.14c0-.28-.23-.51-.51-.51h-5.94c-.28,0-.51.23-.51.51v39.6c0,.28.23.51.51.51h6.47c.28,0,.51-.23.51-.51v-1.94c0-9.57-.54-13.37-.54-13.88,0-.28.23-.51.51-.51s.42.21.46.29c1.23,2.43,4.21,5.48,9.45,5.48ZM413.34,975.68c-4.37,0-7.91-3.63-7.91-8.11s3.54-8.11,7.91-8.11,7.91,3.63,7.91,8.11-3.54,8.11-7.91,8.11Z"
            />
            <path
              fill="#fff"
              d="M447.45,952.38c-8.39,0-14.57,6.8-14.57,15.19s6.41,15.19,15.13,15.19c4.72,0,8.33-1.65,10.74-3.58.21-.17.26-.47.1-.7l-2.68-3.71c-.16-.23-.48-.28-.71-.11-1.19.77-2.93,2.15-6.89,2.15-3.34,0-6.31-1.95-7.71-5.02-.13-.29-.33-.72-.33-.91,0-.28.23-.51.51-.51,0,0,17.38,0,18.59,0,.81,0,1.99-.56,2.06-1.98.45-8.95-4.53-16.03-14.25-16.03ZM453.86,965.23h-13.04c-.28,0-.51-.23-.51-.51,0-.13.12-.55.23-.9,1.06-3.29,3.73-5.22,7.29-5.22,3.01,0,5.26,1.5,6.43,3.8.33.66.61,1.51.61,1.8,0,.56-.45,1.01-1.01,1.01Z"
            />
          </g>
        </g>
        <g>
          <path
            fill="#fff"
            d="M259.81,497.41v20.13c0,2.86.75,4.96,2.25,6.28,1.5,1.33,3.44,1.99,5.82,1.99,1.5,0,3.2-.24,5.11-.72v11.96c-2.45.95-5.42,1.43-8.89,1.43-6.41,0-11.29-1.8-14.67-5.42-3.37-3.61-5.06-8.69-5.06-15.23v-20.44h-9.81v-11.55h9.81v-12.16l15.43-5.01v17.17h13.18v11.55h-13.18Z"
          />
          <path
            fill="#fff"
            d="M298.94,508.65v29.02h-15.43v-75.22h15.43v30.45c1.84-2.72,4.19-4.8,7.05-6.23,2.86-1.43,6.03-2.15,9.5-2.15,12.26,0,18.39,7.26,18.39,21.77v31.37h-15.43v-30.66c0-3.61-.66-6.25-1.99-7.92-1.33-1.67-3.42-2.5-6.28-2.5-3.41,0-6.13,1.09-8.18,3.27-2.04,2.18-3.07,5.11-3.07,8.79"
          />
          <g>
            <path fill="#fff" d="M344.34,485.86h15.43v51.81h-15.43v-51.81Z" />
            <path
              fill="#fff"
              d="M344.01,470.76c0-4.44,3.63-8.06,8.06-8.06s8.06,3.63,8.06,8.06-3.62,8.06-8.06,8.06-8.06-3.62-8.06-8.06"
            />
          </g>
          <path
            fill="#fff"
            d="M420.76,506.3v31.37h-15.43v-30.66c0-3.61-.66-6.25-1.99-7.92-1.33-1.67-3.42-2.5-6.28-2.5-3.41,0-6.13,1.09-8.18,3.27-2.04,2.18-3.07,5.11-3.07,8.79v29.02h-15.43v-36.99c0-5.52-.27-10.46-.82-14.82h14.51l1.02,8.18c1.84-3.07,4.24-5.42,7.2-7.05s6.32-2.45,10.07-2.45c12.26,0,18.39,7.26,18.39,21.77Z"
          />
          <path
            fill="#fff"
            d="M467.04,537.67l-20.34-23.2v23.2h-15.43v-75.22h15.43v45.68l19.42-22.18h18.5l-21.97,24.83,23.3,26.88h-18.91Z"
          />
          <path
            fill="#fff"
            d="M500,535.12c-3.68-2.18-6.52-5.28-8.53-9.3-2.01-4.02-3.01-8.72-3.01-14.1s1-10.08,3.01-14.1c2.01-4.02,4.85-7.12,8.53-9.3,3.68-2.18,7.94-3.27,12.77-3.27s9.09,1.09,12.77,3.27c3.68,2.18,6.52,5.28,8.53,9.3,2.01,4.02,3.01,8.72,3.01,14.1s-1.01,10.08-3.01,14.1c-2.01,4.02-4.85,7.12-8.53,9.3-3.68,2.18-7.94,3.27-12.77,3.27s-9.1-1.09-12.77-3.27ZM524.53,526.48c2.72-3.37,4.09-8.29,4.09-14.77s-1.4-11.12-4.19-14.56c-2.79-3.44-6.68-5.16-11.65-5.16s-8.96,1.72-11.75,5.16c-2.79,3.44-4.19,8.3-4.19,14.56s1.38,11.39,4.14,14.77c2.76,3.37,6.69,5.06,11.8,5.06s9.03-1.69,11.75-5.06Z"
          />
          <path
            fill="#fff"
            d="M565.15,471.5c-1.53,1.53-2.3,4.17-2.3,7.92v6.85h12.57v6.54h-12.57v44.86h-8.28v-44.86h-10.02v-6.54h10.02v-7.87c0-5.38,1.34-9.45,4.04-12.21,2.69-2.76,6.45-4.14,11.29-4.14,2.38,0,4.7.31,6.95.92v7.05c-1.91-.54-3.68-.82-5.31-.82-2.73,0-4.85.77-6.39,2.3Z"
          />
          <path fill="#fff" d="M587.37,462.46h15.43v75.22h-15.43v-75.22Z" />
          <path
            fill="#fff"
            d="M695.91,485.96l-22.79,51.71h-13.08l-22.48-51.71h16.15l13.29,33.52,13.69-33.52h15.23Z"
          />
          <g>
            <path fill="#fff" d="M613.34,485.86h15.43v51.81h-15.43v-51.81Z" />
            <path
              fill="#fff"
              d="M613,470.76c0-4.44,3.63-8.06,8.06-8.06s8.06,3.63,8.06,8.06-3.62,8.06-8.06,8.06-8.06-3.62-8.06-8.06"
            />
          </g>
          <path
            fill="#fff"
            d="M780.93,506.3v31.37h-15.43v-30.66c0-3.61-.66-6.25-1.99-7.92-1.33-1.67-3.42-2.5-6.28-2.5-3.41,0-6.13,1.09-8.18,3.27-2.04,2.18-3.07,5.11-3.07,8.79v29.02h-15.43v-36.99c0-5.52-.27-10.46-.82-14.82h14.51l1.02,8.18c1.84-3.07,4.24-5.42,7.2-7.05,2.96-1.64,6.32-2.45,10.07-2.45,12.26,0,18.39,7.26,18.39,21.77Z"
          />
          <path
            fill="#fff"
            d="M846.42,485.86v49.46c0,8.24-2.39,14.51-7.15,18.8-4.77,4.29-11.72,6.44-20.85,6.44-8.24,0-15.4-1.6-21.46-4.8l2.35-11.45c6.27,3.13,12.47,4.7,18.6,4.7,4.43,0,7.73-1.04,9.91-3.12,2.18-2.08,3.27-5.23,3.27-9.45v-8.99c-1.64,2.52-3.92,4.62-6.85,6.28-2.93,1.67-6.17,2.5-9.71,2.5-4.5,0-8.48-1.07-11.96-3.22-3.47-2.15-6.2-5.18-8.18-9.1-1.98-3.92-2.96-8.43-2.96-13.54s.99-9.62,2.96-13.54c1.98-3.92,4.7-6.95,8.18-9.1,3.48-2.15,7.46-3.22,11.96-3.22,3.61,0,6.88.78,9.81,2.35,2.93,1.57,5.18,3.68,6.74,6.34v-7.36h15.33ZM827.88,520.76c2.15-2.49,3.22-5.94,3.22-10.37s-1.06-7.78-3.17-10.27c-2.11-2.49-5.08-3.73-8.89-3.73s-6.81,1.24-8.99,3.73c-2.18,2.49-3.27,5.91-3.27,10.27s1.09,7.8,3.27,10.32c2.18,2.52,5.18,3.78,8.99,3.78s6.69-1.24,8.84-3.73Z"
          />
          <path
            fill="#fff"
            d="M894.53,531.34c-4.8-4.77-7.2-11.27-7.2-19.52,0-5.38,1.16-10.13,3.47-14.26,2.32-4.12,5.57-7.32,9.76-9.61,4.19-2.28,9.04-3.42,14.56-3.42,3.75,0,7.39.58,10.93,1.74,3.54,1.16,6.37,2.73,8.48,4.7l-4.09,10.73c-2.04-1.64-4.29-2.91-6.75-3.83-2.45-.92-4.84-1.38-7.15-1.38-4.23,0-7.51,1.28-9.86,3.83-2.35,2.56-3.53,6.29-3.53,11.19s1.16,8.74,3.48,11.29c2.32,2.55,5.62,3.83,9.91,3.83,2.32,0,4.7-.46,7.15-1.38s4.7-2.2,6.75-3.83l4.09,10.73c-2.25,1.98-5.18,3.53-8.79,4.65-3.61,1.12-7.39,1.69-11.34,1.69-8.45,0-15.07-2.38-19.88-7.15Z"
          />
          <path
            fill="#fff"
            d="M954.76,535.22c-4.12-2.18-7.29-5.31-9.5-9.4-2.21-4.09-3.32-8.86-3.32-14.31s1.11-10.22,3.32-14.31c2.21-4.09,5.38-7.22,9.5-9.4,4.12-2.18,8.94-3.27,14.46-3.27s10.22,1.09,14.31,3.27c4.09,2.18,7.24,5.31,9.45,9.4,2.21,4.09,3.32,8.86,3.32,14.31s-1.11,10.22-3.32,14.31c-2.21,4.09-5.37,7.22-9.45,9.4-4.09,2.18-8.86,3.27-14.31,3.27s-10.34-1.09-14.46-3.27ZM977.96,522.96c2.01-2.52,3.01-6.34,3.01-11.45s-1.01-8.84-3.01-11.39c-2.01-2.56-4.92-3.83-8.74-3.83s-6.85,1.28-8.89,3.83c-2.04,2.55-3.07,6.35-3.07,11.39,0,10.15,3.99,15.23,11.96,15.23,3.81,0,6.73-1.26,8.74-3.78Z"
          />
          <path
            fill="#fff"
            d="M1083.39,489.89c2.89,3.58,4.34,9.04,4.34,16.4v31.37h-15.43v-30.86c0-3.61-.58-6.22-1.74-7.82-1.16-1.6-3.07-2.4-5.72-2.4-3.14,0-5.55,1.09-7.26,3.27-1.7,2.18-2.55,5.25-2.55,9.2v28.61h-15.43v-30.86c0-3.54-.6-6.13-1.79-7.77-1.19-1.64-3.08-2.45-5.67-2.45-3.14,0-5.57,1.09-7.31,3.27-1.74,2.18-2.61,5.25-2.61,9.2v28.61h-15.43v-36.99c0-5.52-.27-10.46-.82-14.82h14.51l.92,7.77c1.57-2.93,3.76-5.18,6.59-6.74,2.83-1.57,6.08-2.35,9.76-2.35,7.7,0,12.81,3.2,15.33,9.61,1.7-2.93,4.07-5.26,7.1-7,3.03-1.74,6.35-2.61,9.96-2.61,5.93,0,10.34,1.79,13.23,5.36Z"
          />
          <g>
            <path fill="#fff" d="M704.66,485.86h15.43v51.81h-15.43v-51.81Z" />
            <path
              fill="#fff"
              d="M704.32,470.76c0-4.44,3.63-8.06,8.06-8.06s8.06,3.63,8.06,8.06-3.62,8.06-8.06,8.06-8.06-3.62-8.06-8.06"
            />
          </g>
          <path
            fill="#fff"
            d="M856.94,528.55c0-5.88,4.1-10.13,9.98-10.13,5.88,0,9.88,4.14,9.88,10.13,0,5.77-3.99,10.02-9.98,10.03-5.77,0-9.88-4.24-9.88-10.02Z"
          />
        </g>
        <g>
          <g>
            <path
              fill="#fff"
              d="M295.52,573.62h-6.77c-.22,0-.4.14-.47.33,0,0-2.71,7.71-4.09,11.64-.72,2.05-1.93,5.49-2.59,8.04-.05.2-.24.38-.49.38-.22,0-.43-.14-.49-.38-.69-2.56-1.96-6-2.72-8.07-1.72-4.71-4.24-11.62-4.24-11.62-.07-.19-.26-.33-.47-.33h-6.78c-.28,0-.51.23-.51.51,0,.07.01.13.04.19l11.22,28.24-4.39,10.98c-.02.06-.04.12-.04.19,0,.28.23.51.51.51h6.57c.21,0,.4-.13.47-.32l15.73-39.6c.02-.06.03-.12.03-.18,0-.28-.23-.51-.51-.51Z"
            />
            <path
              fill="#fff"
              d="M242.47,578.5c-.04.08-.18.29-.46.29s-.51-.23-.51-.51c0-.51.54-4.31.54-13.88v-2.95c0-.28-.23-.51-.51-.51h-6.47c-.28,0-.51.23-.51.51v40.61c0,.28.23.51.51.51h5.94c.28,0,.51-.22.51-.5v-4.14c0-.28.23-.51.51-.51.16,0,.35.07.47.3.6,1.22,3.16,5.44,9.44,5.44,7.46,0,13.57-6.51,13.57-15.07s-6.11-15.07-13.57-15.07c-5.24,0-8.23,3.04-9.45,5.48ZM258.01,588.09c0,4.48-3.54,8.11-7.91,8.11s-7.91-3.63-7.91-8.11,3.54-8.11,7.91-8.11,7.91,3.63,7.91,8.11Z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M560.06,586.19c-.28,0-.51-.23-.51-.51v-6c0-.28.23-.51.51-.51h17.52c1.2,0,1.98.98,2.02,1.94,0,0,.04,1,0,2.03-.34,11.88-7.62,20.2-19.34,20.2s-20.53-9.52-20.53-21.41,8.83-21.66,20.72-21.66c9.34,0,14.26,5.87,14.54,6.11.2.19.21.51.02.71l-4.45,4.72c-.19.2-.51.21-.71.02-.24-.25-3.63-4.2-9.39-4.2-7.76,0-13.11,6.54-13.11,14.3s5.39,14.11,12.98,14.11c6.05,0,10.37-3.21,11.41-8.48.03-.17.05-.28.05-.37,0-.56-.45-1.01-1.01-1.01h-10.72Z"
            />
            <path
              fill="#fff"
              d="M594.09,603.03c-5.67,0-9.92-4.15-9.92-11.57v-17.34c0-.28.23-.51.51-.51h6.47c.28,0,.51.23.51.51v15.52c0,4.53,2.01,6.71,5.7,6.71s5.95-2.35,5.95-6.71v-15.52c0-.28.23-.51.51-.51h6.47c.28,0,.51.23.51.51v27.93c0,.28-.23.51-.51.51h-2.53s-1.53,0-1.53,0h-1.88c-.28,0-.51-.22-.51-.5v-5.15c0-.28-.23-.51-.51-.51s-.45.17-.52.44c-.7,2.41-2.89,6.19-8.71,6.19Z"
            />
            <path
              fill="#fff"
              d="M378.02,572.9c-8.39,0-15.19,6.8-15.19,15.2s6.8,15.19,15.19,15.19,15.19-6.8,15.19-15.19-6.8-15.2-15.19-15.2ZM378.02,596.2c-4.37,0-7.91-3.63-7.91-8.11s3.54-8.11,7.91-8.11,7.91,3.63,7.91,8.11-3.54,8.11-7.91,8.11Z"
            />
            <path
              fill="#fff"
              d="M356.87,580.09c-1.82,0-3.65.9-4.68,3.02-.72,1.48-.96,3.54-.96,6.3v12.64c.01.28-.21.51-.49.51h-6.47c-.28,0-.51-.23-.51-.51v-27.93c0-.28.23-.51.51-.51h5.94c.28,0,.51.22.51.5v5.15c0,.28.23.51.51.51s.44-.19.52-.46c.51-1.75,1.31-3.88,2.95-5.24.9-.74,2.03-1.08,3.16-1.08.95,0,1.97.23,3.02.9.14.09.22.24.22.42v6.33c0,.28-.23.51-.51.51-.1,0-.2-.04-.28-.09-.87-.49-1.98-.97-3.43-.97Z"
            />
            <path
              fill="#fff"
              d="M480.06,580.09c-1.82,0-3.65.9-4.68,3.02-.72,1.48-.96,3.54-.96,6.3v12.64c.01.28-.21.51-.49.51h-6.47c-.28,0-.51-.23-.51-.51v-27.93c0-.28.23-.51.51-.51h5.94c.28,0,.51.22.51.5v5.15c0,.28.23.51.51.51s.44-.19.52-.46c.51-1.75,1.31-3.88,2.95-5.24.9-.74,2.03-1.08,3.16-1.08.95,0,1.97.23,3.02.9.14.09.22.24.22.42v6.33c0,.28-.23.51-.51.51-.1,0-.2-.04-.28-.09-.87-.49-1.98-.97-3.43-.97Z"
            />
            <path
              fill="#fff"
              d="M630.33,580.09c-1.82,0-3.65.9-4.68,3.02-.72,1.48-.96,3.54-.96,6.3v12.64c.01.28-.21.51-.49.51h-6.47c-.28,0-.51-.23-.51-.51v-27.93c0-.28.23-.51.51-.51h5.94c.28,0,.51.22.51.5v5.15c0,.28.23.51.51.51s.44-.19.52-.46c.51-1.75,1.31-3.88,2.95-5.24.9-.74,2.03-1.08,3.16-1.08.95,0,1.97.23,3.02.9.14.09.22.24.22.42v6.33c0,.28-.23.51-.51.51-.1,0-.2-.04-.28-.09-.87-.49-1.98-.97-3.43-.97Z"
            />
            <path
              fill="#fff"
              d="M648.48,603.03c-5.67,0-9.92-4.15-9.92-11.57v-17.34c0-.28.23-.51.51-.51h6.47c.28,0,.51.23.51.51v15.52c0,4.53,2.01,6.71,5.7,6.71s5.95-2.35,5.95-6.71v-15.52c0-.28.23-.51.51-.51h6.47c.28,0,.51.23.51.51v27.93c0,.28-.23.51-.51.51h-2.53s-1.53,0-1.53,0h-1.88c-.28,0-.51-.22-.51-.5v-5.15c0-.28-.23-.51-.51-.51s-.45.17-.52.44c-.7,2.41-2.89,6.19-8.71,6.19Z"
            />
            <path
              fill="#fff"
              d="M535.3,573.62h-6.77c-.22,0-.4.14-.47.33,0,0-2.71,7.71-4.09,11.64-.72,2.05-1.93,5.49-2.59,8.04-.05.2-.24.38-.49.38-.22,0-.43-.14-.49-.38-.69-2.56-1.96-6-2.72-8.07-1.72-4.71-4.24-11.62-4.24-11.62-.07-.19-.26-.33-.47-.33h-6.78c-.28,0-.51.23-.51.51,0,.07.01.13.04.19l11.22,28.24-4.39,10.98c-.02.06-.04.12-.04.19,0,.28.23.51.51.51h6.57c.21,0,.4-.13.47-.32l15.73-39.6c.02-.06.03-.12.03-.18,0-.28-.23-.51-.51-.51Z"
            />
            <path
              fill="#fff"
              d="M324.38,560.93h-12.92c-1.12,0-2.02.9-2.02,2.02v39.1c0,.28.23.51.51.51h6.46c.28,0,.51-.23.51-.51v-9.72c0-.56.45-1.01,1.01-1.01h6.45c8.65,0,15.45-6.8,15.45-15.19s-6.8-15.2-15.45-15.2ZM323.73,584.5h-5.8c-.56,0-1.01-.45-1.01-1.01v-14.72c0-.56.45-1.01,1.01-1.01h5.8c4.88,0,8.63,3.75,8.63,8.37s-3.75,8.37-8.63,8.37Z"
            />
            <path
              fill="#fff"
              d="M495.77,580.54c0-.28.23-.51.51-.51h5.99c.28,0,.51-.23.51-.51v-5.4c0-.28-.23-.51-.51-.51h-6.68c-.28,0-.51-.23-.51-.51v-6.72c0-.28-.23-.51-.51-.51h-5.78c-.28,0-.51.23-.51.51v27.39c0,7.06,3.43,9.5,7.91,9.5,2.85,0,4.54-.87,5.25-1.21.22-.1.33-.28.33-.53v-4.38c-.01-.34-.33-.62-.75-.47-.91.34-1.68.56-2.61.56-1.34,0-2.66-.63-2.66-3.1v-13.63Z"
            />
            <path
              fill="#fff"
              d="M415.17,603.16c7.46,0,13.57-6.51,13.57-15.07s-6.11-15.07-13.57-15.07c-6.28,0-8.84,4.22-9.44,5.44-.12.24-.31.3-.47.3-.28,0-.51-.23-.51-.51v-4.14c0-.28-.23-.51-.51-.51h-5.94c-.28,0-.51.23-.51.51v39.6c0,.28.23.51.51.51h6.47c.28,0,.51-.23.51-.51v-1.94c0-9.57-.54-13.37-.54-13.88,0-.28.23-.51.51-.51s.42.21.46.29c1.23,2.43,4.21,5.48,9.45,5.48ZM413.34,596.2c-4.37,0-7.91-3.63-7.91-8.11s3.54-8.11,7.91-8.11,7.91,3.63,7.91,8.11-3.54,8.11-7.91,8.11Z"
            />
            <path
              fill="#fff"
              d="M447.45,572.9c-8.39,0-14.57,6.8-14.57,15.19s6.41,15.19,15.13,15.19c4.72,0,8.33-1.65,10.74-3.58.21-.17.26-.47.1-.7l-2.68-3.71c-.16-.23-.48-.28-.71-.11-1.19.77-2.93,2.15-6.89,2.15-3.34,0-6.31-1.95-7.71-5.02-.13-.29-.33-.72-.33-.91,0-.28.23-.51.51-.51,0,0,17.38,0,18.59,0,.81,0,1.99-.56,2.06-1.98.45-8.95-4.53-16.03-14.25-16.03ZM453.86,585.75h-13.04c-.28,0-.51-.23-.51-.51,0-.13.12-.55.23-.9,1.06-3.29,3.73-5.22,7.29-5.22,3.01,0,5.26,1.5,6.43,3.8.33.66.61,1.51.61,1.8,0,.56-.45,1.01-1.01,1.01Z"
            />
          </g>
        </g>
        <path
          fill="#fff"
          d="M147,455.62c-34.33,0-62.16,24.21-62.16,54.1,0,.88.03,1.75.07,2.62,0,.13.02.25.02.37,2.61,44.68,62.07,102.41,62.07,102.41,0,0,59.44-57.73,62.05-102.41.01-.12.01-.24.02-.37.05-.87.07-1.74.07-2.62,0-29.89-27.81-54.1-62.15-54.1ZM189.93,524.66c-2.79,3.55-7.94,4.2-11.52,1.42l-2.81-2.18-3.58,28.22c-.17,1.47-.79,2.88-1.64,3.91-.85,1.03-1.93,1.63-2.95,1.63h-9.21c-3.73,0-3.76-3.48-3.74-3.96v-.06l.57-13.33c.04-1.88-1.13-3.41-2.65-3.41h-10.62c-1.51,0-2.67,1.53-2.59,3.41l.84,13.33s.26,4.02-3.74,4.02h-9.15c-1.01,0-2.11-.6-2.98-1.63-.88-1.04-1.51-2.45-1.72-3.91l-4.03-28.25-2.82,2.2v.02c-1.5,1.16-3.28,1.74-5.04,1.74-2.44,0-4.86-1.09-6.48-3.17-2.79-3.57-2.14-8.72,1.43-11.51l36.45-28.37c2.97-2.31,7.09-2.31,10.07,0l36.47,28.37c3.57,2.79,4.21,7.94,1.43,11.51Z"
        />
        <path
          fill="#0081c6"
          d="M189.93,524.66c-2.79,3.55-7.94,4.2-11.52,1.42l-2.81-2.18-3.58,28.22c-.17,1.47-.79,2.88-1.64,3.91-.85,1.03-1.93,1.63-2.95,1.63h-9.21c-3.73,0-3.76-3.48-3.74-3.96v-.06l.57-13.33c.04-1.88-1.13-3.41-2.65-3.41h-10.62c-1.51,0-2.67,1.53-2.59,3.41l.84,13.33s.26,4.02-3.74,4.02h-9.15c-1.01,0-2.11-.6-2.98-1.63-.88-1.04-1.51-2.45-1.72-3.91l-4.03-28.25-2.82,2.2v.02c-1.5,1.16-3.28,1.74-5.04,1.74-2.44,0-4.86-1.09-6.48-3.17-2.79-3.57-2.14-8.72,1.43-11.51l36.45-28.37c2.97-2.31,7.09-2.31,10.07,0l36.47,28.37c3.57,2.79,4.21,7.94,1.43,11.51Z"
        />
        <g>
          <path
            fill="#fff"
            d="M259.81,876.89v20.13c0,2.86.75,4.96,2.25,6.28,1.5,1.33,3.44,1.99,5.82,1.99,1.5,0,3.2-.24,5.11-.72v11.96c-2.45.95-5.42,1.43-8.89,1.43-6.41,0-11.29-1.8-14.67-5.42-3.37-3.61-5.06-8.69-5.06-15.23v-20.44h-9.81v-11.55h9.81v-12.16l15.43-5.01v17.17h13.18v11.55h-13.18Z"
          />
          <path
            fill="#fff"
            d="M298.94,888.13v29.02h-15.43v-75.22h15.43v30.45c1.84-2.72,4.19-4.8,7.05-6.23,2.86-1.43,6.03-2.15,9.5-2.15,12.26,0,18.39,7.26,18.39,21.77v31.37h-15.43v-30.66c0-3.61-.66-6.25-1.99-7.92-1.33-1.67-3.42-2.5-6.28-2.5-3.41,0-6.13,1.09-8.18,3.27-2.04,2.18-3.07,5.11-3.07,8.79"
          />
          <g>
            <path fill="#fff" d="M344.34,865.34h15.43v51.81h-15.43v-51.81Z" />
            <path
              fill="#fff"
              d="M344.01,850.24c0-4.44,3.63-8.06,8.06-8.06s8.06,3.63,8.06,8.06-3.62,8.06-8.06,8.06-8.06-3.62-8.06-8.06"
            />
          </g>
          <path
            fill="#fff"
            d="M420.76,885.78v31.37h-15.43v-30.66c0-3.61-.66-6.25-1.99-7.92-1.33-1.67-3.42-2.5-6.28-2.5-3.41,0-6.13,1.09-8.18,3.27-2.04,2.18-3.07,5.11-3.07,8.79v29.02h-15.43v-36.99c0-5.52-.27-10.46-.82-14.82h14.51l1.02,8.18c1.84-3.07,4.24-5.42,7.2-7.05s6.32-2.45,10.07-2.45c12.26,0,18.39,7.26,18.39,21.77Z"
          />
          <path
            fill="#fff"
            d="M467.04,917.15l-20.34-23.2v23.2h-15.43v-75.22h15.43v45.68l19.42-22.18h18.5l-21.97,24.83,23.3,26.88h-18.91Z"
          />
          <path
            fill="#fff"
            d="M500,914.6c-3.68-2.18-6.52-5.28-8.53-9.3-2.01-4.02-3.01-8.72-3.01-14.1s1-10.08,3.01-14.1c2.01-4.02,4.85-7.12,8.53-9.3,3.68-2.18,7.94-3.27,12.77-3.27s9.09,1.09,12.77,3.27c3.68,2.18,6.52,5.28,8.53,9.3,2.01,4.02,3.01,8.72,3.01,14.1s-1.01,10.08-3.01,14.1c-2.01,4.02-4.85,7.12-8.53,9.3-3.68,2.18-7.94,3.27-12.77,3.27s-9.1-1.09-12.77-3.27ZM524.53,905.96c2.72-3.37,4.09-8.29,4.09-14.77s-1.4-11.12-4.19-14.56c-2.79-3.44-6.68-5.16-11.65-5.16s-8.96,1.72-11.75,5.16c-2.79,3.44-4.19,8.3-4.19,14.56s1.38,11.39,4.14,14.77c2.76,3.37,6.69,5.06,11.8,5.06s9.03-1.69,11.75-5.06Z"
          />
          <path
            fill="#fff"
            d="M565.15,850.98c-1.53,1.53-2.3,4.17-2.3,7.92v6.85h12.57v6.54h-12.57v44.86h-8.28v-44.86h-10.02v-6.54h10.02v-7.87c0-5.38,1.34-9.45,4.04-12.21,2.69-2.76,6.45-4.14,11.29-4.14,2.38,0,4.7.31,6.95.92v7.05c-1.91-.54-3.68-.82-5.31-.82-2.73,0-4.85.77-6.39,2.3Z"
          />
          <path fill="#fff" d="M587.37,841.94h15.43v75.22h-15.43v-75.22Z" />
          <path
            fill="#fff"
            d="M695.91,865.44l-22.79,51.71h-13.08l-22.48-51.71h16.15l13.29,33.52,13.69-33.52h15.23Z"
          />
          <g>
            <path fill="#fff" d="M613.34,865.34h15.43v51.81h-15.43v-51.81Z" />
            <path
              fill="#fff"
              d="M613,850.24c0-4.44,3.63-8.06,8.06-8.06s8.06,3.63,8.06,8.06-3.62,8.06-8.06,8.06-8.06-3.62-8.06-8.06"
            />
          </g>
          <path
            fill="#fff"
            d="M780.93,885.78v31.37h-15.43v-30.66c0-3.61-.66-6.25-1.99-7.92-1.33-1.67-3.42-2.5-6.28-2.5-3.41,0-6.13,1.09-8.18,3.27-2.04,2.18-3.07,5.11-3.07,8.79v29.02h-15.43v-36.99c0-5.52-.27-10.46-.82-14.82h14.51l1.02,8.18c1.84-3.07,4.24-5.42,7.2-7.05,2.96-1.64,6.32-2.45,10.07-2.45,12.26,0,18.39,7.26,18.39,21.77Z"
          />
          <path
            fill="#fff"
            d="M846.42,865.34v49.46c0,8.24-2.39,14.51-7.15,18.8-4.77,4.29-11.72,6.44-20.85,6.44-8.24,0-15.4-1.6-21.46-4.8l2.35-11.45c6.27,3.13,12.47,4.7,18.6,4.7,4.43,0,7.73-1.04,9.91-3.12,2.18-2.08,3.27-5.23,3.27-9.45v-8.99c-1.64,2.52-3.92,4.62-6.85,6.28-2.93,1.67-6.17,2.5-9.71,2.5-4.5,0-8.48-1.07-11.96-3.22-3.47-2.15-6.2-5.18-8.18-9.1-1.98-3.92-2.96-8.43-2.96-13.54s.99-9.62,2.96-13.54c1.98-3.92,4.7-6.95,8.18-9.1,3.48-2.15,7.46-3.22,11.96-3.22,3.61,0,6.88.78,9.81,2.35,2.93,1.57,5.18,3.68,6.74,6.34v-7.36h15.33ZM827.88,900.24c2.15-2.49,3.22-5.94,3.22-10.37s-1.06-7.78-3.17-10.27c-2.11-2.49-5.08-3.73-8.89-3.73s-6.81,1.24-8.99,3.73c-2.18,2.49-3.27,5.91-3.27,10.27s1.09,7.8,3.27,10.32c2.18,2.52,5.18,3.78,8.99,3.78s6.69-1.24,8.84-3.73Z"
          />
          <path
            fill="#fff"
            d="M894.53,910.82c-4.8-4.77-7.2-11.27-7.2-19.52,0-5.38,1.16-10.13,3.47-14.26,2.32-4.12,5.57-7.32,9.76-9.61,4.19-2.28,9.04-3.42,14.56-3.42,3.75,0,7.39.58,10.93,1.74,3.54,1.16,6.37,2.73,8.48,4.7l-4.09,10.73c-2.04-1.64-4.29-2.91-6.75-3.83-2.45-.92-4.84-1.38-7.15-1.38-4.23,0-7.51,1.28-9.86,3.83-2.35,2.56-3.53,6.29-3.53,11.19s1.16,8.74,3.48,11.29c2.32,2.55,5.62,3.83,9.91,3.83,2.32,0,4.7-.46,7.15-1.38s4.7-2.2,6.75-3.83l4.09,10.73c-2.25,1.98-5.18,3.53-8.79,4.65-3.61,1.12-7.39,1.69-11.34,1.69-8.45,0-15.07-2.38-19.88-7.15Z"
          />
          <path
            fill="#fff"
            d="M954.76,914.7c-4.12-2.18-7.29-5.31-9.5-9.4-2.21-4.09-3.32-8.86-3.32-14.31s1.11-10.22,3.32-14.31c2.21-4.09,5.38-7.22,9.5-9.4,4.12-2.18,8.94-3.27,14.46-3.27s10.22,1.09,14.31,3.27c4.09,2.18,7.24,5.31,9.45,9.4,2.21,4.09,3.32,8.86,3.32,14.31s-1.11,10.22-3.32,14.31c-2.21,4.09-5.37,7.22-9.45,9.4-4.09,2.18-8.86,3.27-14.31,3.27s-10.34-1.09-14.46-3.27ZM977.96,902.44c2.01-2.52,3.01-6.34,3.01-11.45s-1.01-8.84-3.01-11.39c-2.01-2.56-4.92-3.83-8.74-3.83s-6.85,1.28-8.89,3.83c-2.04,2.55-3.07,6.35-3.07,11.39,0,10.15,3.99,15.23,11.96,15.23,3.81,0,6.73-1.26,8.74-3.78Z"
          />
          <path
            fill="#fff"
            d="M1083.39,869.38c2.89,3.58,4.34,9.04,4.34,16.4v31.37h-15.43v-30.86c0-3.61-.58-6.22-1.74-7.82-1.16-1.6-3.07-2.4-5.72-2.4-3.14,0-5.55,1.09-7.26,3.27-1.7,2.18-2.55,5.25-2.55,9.2v28.61h-15.43v-30.86c0-3.54-.6-6.13-1.79-7.77-1.19-1.64-3.08-2.45-5.67-2.45-3.14,0-5.57,1.09-7.31,3.27-1.74,2.18-2.61,5.25-2.61,9.2v28.61h-15.43v-36.99c0-5.52-.27-10.46-.82-14.82h14.51l.92,7.77c1.57-2.93,3.76-5.18,6.59-6.74,2.83-1.57,6.08-2.35,9.76-2.35,7.7,0,12.81,3.2,15.33,9.61,1.7-2.93,4.07-5.26,7.1-7,3.03-1.74,6.35-2.61,9.96-2.61,5.93,0,10.34,1.79,13.23,5.36Z"
          />
          <g>
            <path fill="#fff" d="M704.66,865.34h15.43v51.81h-15.43v-51.81Z" />
            <path
              fill="#fff"
              d="M704.32,850.24c0-4.44,3.63-8.06,8.06-8.06s8.06,3.63,8.06,8.06-3.62,8.06-8.06,8.06-8.06-3.62-8.06-8.06"
            />
          </g>
          <path
            fill="#fff"
            d="M856.94,908.03c0-5.88,4.1-10.13,9.98-10.13,5.88,0,9.88,4.14,9.88,10.13,0,5.77-3.99,10.02-9.98,10.03-5.77,0-9.88-4.24-9.88-10.02Z"
          />
        </g>
        <path
          fill="#fff"
          d="M147,835.1c-34.33,0-62.16,24.21-62.16,54.1,0,.88.03,1.75.07,2.62,0,.13.02.25.02.37,2.61,44.68,62.07,102.41,62.07,102.41,0,0,59.44-57.73,62.05-102.41.01-.12.01-.24.02-.37.05-.87.07-1.74.07-2.62,0-29.89-27.81-54.1-62.15-54.1ZM189.93,904.14c-2.79,3.55-7.94,4.2-11.52,1.42l-2.81-2.18-3.58,28.22c-.17,1.47-.79,2.88-1.64,3.91-.85,1.03-1.93,1.63-2.95,1.63h-9.21c-3.73,0-3.76-3.48-3.74-3.96v-.06l.57-13.33c.04-1.88-1.13-3.41-2.65-3.41h-10.62c-1.51,0-2.67,1.53-2.59,3.41l.84,13.33s.26,4.02-3.74,4.02h-9.15c-1.01,0-2.11-.6-2.98-1.63-.88-1.04-1.51-2.45-1.72-3.91l-4.03-28.25-2.82,2.2v.02c-1.5,1.16-3.28,1.74-5.04,1.74-2.44,0-4.86-1.09-6.48-3.17-2.79-3.57-2.14-8.72,1.43-11.51l36.45-28.37c2.97-2.31,7.09-2.31,10.07,0l36.47,28.37c3.57,2.79,4.21,7.94,1.43,11.51Z"
        />
      </g>
    </g>
  </svg>
);

export default Logo;
